if (!customElements.get('custom-size-handler')) {
  customElements.define(
    'custom-size-handler',
    class CustomSizeHandler extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector('.custom-size-inputs');
        this.requiredInputs = this.querySelectorAll('.custom-size-inputs__input[required]');
        this.optionalInputs = this.querySelectorAll('.custom-size-inputs__input:not([required])');
        this.isCustomSizeActive = false;
      }

      connectedCallback() {
        // Wait a bit for the DOM to be fully ready
        setTimeout(() => this.init(), 100);
      }

      init() {
        const productInfo = this.closest('product-info');
        if (!productInfo) {
          console.warn('custom-size-handler: product-info not found');
          return;
        }

        // Use event delegation on the product-info level
        productInfo.addEventListener('change', (event) => {
          // Check if the change is from a Size option
          const target = event.target;
          
          // Check for radio buttons
          if (target.type === 'radio' && target.name && target.name.includes('Size')) {
            this.handleSizeChange(target.value);
          }
          
          // Check for select dropdowns
          if (target.tagName === 'SELECT' && target.name && target.name.includes('Size')) {
            this.handleSizeChange(target.value);
          }
        });

        // Also listen for clicks on labels (for radio buttons)
        productInfo.addEventListener('click', (event) => {
          const label = event.target.closest('label');
          if (label && label.hasAttribute('for')) {
            const input = document.getElementById(label.getAttribute('for'));
            if (input && input.type === 'radio' && input.name && input.name.includes('Size')) {
              setTimeout(() => this.handleSizeChange(input.value), 10);
            }
          }
        });

        // Add form submit validation
        this.setupFormValidation(productInfo);

        // Initial check
        this.checkCurrentSize();
      }

      setupFormValidation(productInfo) {
        // Find the product form
        const productForm = productInfo.querySelector('form[data-type="add-to-cart-form"]');
        if (!productForm) {
          console.warn('custom-size-handler: product form not found');
          return;
        }

        // Intercept form submission
        productForm.addEventListener('submit', (event) => {
          if (this.isCustomSizeActive && !this.validateRequiredFields()) {
            event.preventDefault();
            event.stopPropagation();
            this.showValidationError();
            return false;
          }
        }, true); // Use capture phase to run before other handlers
      }

      validateRequiredFields() {
        let allValid = true;
        
        this.requiredInputs.forEach(input => {
          const value = input.value.trim();
          
          // Remove previous error state
          input.classList.remove('error');
          
          if (!value || value === '') {
            allValid = false;
            input.classList.add('error');
          }
        });

        return allValid;
      }

      showValidationError() {
        // Scroll to the first empty required field
        const firstEmptyField = Array.from(this.requiredInputs).find(input => !input.value.trim());
        
        if (firstEmptyField) {
          firstEmptyField.focus();
          firstEmptyField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Show error message
        const productForm = this.closest('product-info')?.querySelector('product-form');
        if (productForm) {
          const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          const errorMessage = productForm.querySelector('.product-form__error-message');
          
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = 'Please fill in all required custom measurements (Bust/Chest, Waist, Hip)';
            errorWrapper.hidden = false;
            
            // Auto-hide after 5 seconds
            setTimeout(() => {
              errorWrapper.hidden = true;
            }, 5000);
          }
        }

        // Also show browser alert as fallback
        alert('Please fill in all required custom measurements:\n• Bust/Chest\n• Waist\n• Hip');
      }

      handleSizeChange(selectedValue) {
        console.log('Size changed to:', selectedValue);
        this.toggleCustomInputs(selectedValue);
      }

      checkCurrentSize() {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const variantSelects = productInfo.querySelector('variant-selects');
        if (!variantSelects) return;

        // Check radio buttons - try multiple selectors
        let checkedRadio = variantSelects.querySelector('input[type="radio"][name*="Size"]:checked');
        if (!checkedRadio) {
          checkedRadio = variantSelects.querySelector('input[type="radio"][name*="size"]:checked');
        }
        
        if (checkedRadio) {
          this.toggleCustomInputs(checkedRadio.value);
          return;
        }

        // Check dropdown - try multiple selectors
        let sizeSelect = variantSelects.querySelector('select[name*="Size"]');
        if (!sizeSelect) {
          sizeSelect = variantSelects.querySelector('select[name*="size"]');
        }
        
        if (sizeSelect) {
          this.toggleCustomInputs(sizeSelect.value);
        }
      }

      toggleCustomInputs(sizeValue) {
        if (!this.container) return;

        // Check if the selected size is "Custom" (case insensitive)
        const isCustom = sizeValue && sizeValue.toLowerCase().includes('custom');
        
        console.log('Toggling custom inputs:', { sizeValue, isCustom });
        
        this.isCustomSizeActive = isCustom;
        
        if (isCustom) {
          this.container.classList.add('active');
        } else {
          this.container.classList.remove('active');
          // Clear all input values and errors when hidden
          this.requiredInputs.forEach(input => {
            input.value = '';
            input.classList.remove('error');
          });
          this.optionalInputs.forEach(input => {
            input.value = '';
          });
        }
      }
    }
  );
}
